<template>
  <div v-if="voucherInfoData && voucherInfoData.info.id > 0" id="printMe">
    <layout-print-voucher
      :customer-name="concatFullname(voucherInfoData.info.customer.last_name, voucherInfoData.info.customer.first_name)"
      :customer-email="voucherInfoData.info.customer.email"
      :voucher-price="voucherInfoData.info.value"
      :voucher-name="voucherInfoData.issuanceInfo.name"
      :voucher-type="voucherInfoData.issuanceInfo.type"
      :voucher-serial="voucherInfoData.info.serial"
      :activation-code="voucherInfoData.info.activation_code"
      :supplier-name="voucherInfoData.issuanceInfo.owner.name"
      :supplier-hotline="voucherInfoData.issuanceInfo.owner.phone"
      :supplier-website="voucherInfoData.issuanceInfo.owner.website"
      :expired-date="formatDate(voucherInfoData.info.expired_date)"
      :voucher-description="voucherInfoData.issuanceInfo.description"
      :voucher-term-of-conditions="voucherInfoData.issuanceInfo.conditions_of_use"
      :voucher-details="voucherInfoData.issuanceInfo.details"
      :logo-supplier-url="voucherInfoData.issuanceInfo.owner.image_url"
      :logo-agent-url="voucherInfoData.distributerInfo.image_url"
      :background-url="voucherInfoData.printTemplateInfo.backgroundUrl"
      :second-background-url="voucherInfoData.printTemplateInfo.secondBackgroundUrl"
      :is-hide-price="voucherInfoData.issuanceInfo.is_hide_price"
    />
    <div
      class="voucher-print-button"
      style="position: fixed; bottom: 0; left: 10px;">
      <b-button
        size="md"
        variant="success"
        class="mb-2"
        @click="onPrintPage($event)"
      >
        <i class="fas fa-print" />
      </b-button>
    </div>
  </div>
  <div v-else>
    <div class="error-content">
      <span>{{ $t('lookUpVoucher.invalidVoucherMessage') }} <a href="/look-up-voucher">{{ $t('lookUpVoucher.title') }}</a></span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import dateUtils from 'Utils/dateUtils'
import { FOR_CONASI_TARGET } from 'Utils/constants'
import functionUtils from 'Utils/functionUtils'
import LayoutPrintVoucher from './LayoutPrintVoucher'
import PrintTemplateItemKind from 'Enum/printTemplateItemKind'
export default {
  components: {
    LayoutPrintVoucher
  },
  data: () => ({
    voucherInfoData: null,
    forConasi: FOR_CONASI_TARGET
  }),
  computed: {
    ...mapGetters(['E_VOUCHER_PRINT_DATA'])
  },
  watch: {
    E_VOUCHER_PRINT_DATA () {
      let data = this.E_VOUCHER_PRINT_DATA
      let printTemplateInfo = {
        backgroundUrl: null,
        secondBackgroundUrl: null
      }
      data.template_info.forEach(e => {
        if (e.kind === PrintTemplateItemKind.BACKGROUND_IMAGE) {
          printTemplateInfo.backgroundUrl = e.value
        } else if (e.kind === PrintTemplateItemKind.BACKGROUND_2ND_IMAGE) {
          printTemplateInfo.secondBackgroundUrl = e.value
        }
      })
      let voucherObj = {
        info: data.voucher_info,
        issuanceInfo: data.workpiece,
        distributerInfo: data.distributer,
        printTemplateInfo: printTemplateInfo
      }
      this.voucherInfoData = voucherObj
    }
  },
  created () {
    let routerParam = this.$route.params
    let voucherId = routerParam && routerParam.id
    let serial = routerParam && routerParam.serial
    let filter = {
      params: {
        id: voucherId,
        serial: serial
      }
    }
    this.isLoading = true
    this.GET_VOUCHERS_PRINT(filter).then(
      function () {
      }
    ).catch(
      function () {
      }.bind(this)
    )
  },
  beforeCreate: function () {
    document.body.className = 'print'
  },
  methods: {
    onPrintPage: function () {
      this.$htmlToPaper('printMe');
    },
    concatFullname: function (lastname, firstname) {
      return functionUtils.concatFullname(lastname, firstname)
    },
    formatDate: function (date) {
      return date ? dateUtils.formatDate(date, dateUtils.STATIC_FORMAT_DATE_TIME_ZONE, dateUtils.STATIC_FORMAT_DATE) : null
    },
    ...mapActions(['GET_VOUCHERS_PRINT'])
  }
}
</script>

<style lang="scss" scoped>
.error-content {
  width: 100vw;
  height: 90vh;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px 30px;
}
</style>